export interface PresentationPrototype {
    _id: string;
    content: string;
    type?: PresentationPrototypeType;
}

export enum PresentationPrototypeType {
    MEDICAL_CASE = 'Medical Case',
}

export interface PresentationPrototypeRequest {
    prompt: string;
    type?: PresentationPrototypeType;
    // When set, fills an existing empty chat (created via /new) instead of starting a new one.
    id?: string;
}

export interface ModifyPresentationPrototypeRequest {
    id: string;
    prompt: string;
}

export interface PresentationPrototypeItem {
    _id: string;
    presentationPrototypeId: string;
    prompt: string;
    content: string;
    created: Date;
}

export type PresentationPrototypeItemDTO = Pick<PresentationPrototypeItem, '_id' | 'prompt' | 'created'>;
